import { useRefGetter } from '../../use';
import { useEffect, useRef } from 'react';
import { addMutationHandler, getDefaultElementSize, getWindowSize, isClient, isElementSizeEqual, removeMutationHandler } from '../../co-dom';
export function useWindowSize(enable, onResize) {
  var sizeRef = useRef(getDefaultElementSize());
  var enableGetter = useRefGetter(enable);
  var onResizeGetter = useRefGetter(onResize);
  useEffect(function () {
    var update = function update() {
      if (!enableGetter()()) {
        return;
      }

      var currentSize = getWindowSize();
      var oldSize = sizeRef.current;

      if (!isElementSizeEqual(sizeRef.current, currentSize)) {
        var handler = onResizeGetter();
        sizeRef.current = currentSize;
        handler && handler(currentSize, oldSize);
      }
    };

    update();

    if (isClient()) {
      addMutationHandler(update, {
        resize: true
      });
      return function () {
        return removeMutationHandler(update);
      };
    }
  }, []);
  return sizeRef.current;
}